// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606042351/js/" + chunkId + "." + {"44":"e02e7d6a","225":"10545faa","481":"1cc45ce5","486":"55ae2512","770":"4eb95ad5"}[chunkId] + ".0.5422473993506347.chunk.js";
};